import { useEvent } from 'hooks'

import { selectors } from './paginator.selector'

export const PaginatorComponent = (() => {
	const init = () => {
		const paginatorTargets = selectors.getPaginatioHandlers()
		for (let i = 0; i < paginatorTargets.length; i++) {
			const paginatorWrapper = paginatorTargets[i]
			const handle = paginatorWrapper.dataset.selectPaginatorHandle
			if (!handle) {
				break
			}

			const { itemsPerPageParameterId } = paginatorWrapper.dataset
			if (!itemsPerPageParameterId) {
				break
			}

			const wrapperChangeEvent = useEvent(paginatorWrapper, 'change')

			wrapperChangeEvent.register(() => {
				const data = {}
				data[itemsPerPageParameterId] = paginatorWrapper.value
				// @ts-ignore
				$.nette.ajax({
					type: 'GET',
					url: handle,
					data,
				})
			})
		}
	}

	return { init }
})()
